function Service({ title, text, img, alt }) {
    return (
        <div className="service">
            <div className="service-img">
                <img src={img} alt={alt} />
            </div>

            <div className="service-bottom">
                <p className="service-title">{title}</p>
                <p className="service-text">{text}</p>
            </div>
        </div>
    )
}

export default Service;